const items = [
    {
      id: 1,
      title: "1 Homemade Cheesecake with Fresh Berries and Mint",
      img: "/assets/img/card-thumb-1.jpg",
      detail: "10.12.2019",
      category: "Cupcakes",
      badges: [
        {
          color: "theme-1",
          title: "NEW"
        },
        {
          color: "theme-2",
          title: "ONHOLD"
        }
      ]
    },
    {
      id: 2,
      title: "2 Wedding Cake with Flowers Macarons and Blueberries",
      img: "/assets/img/card-thumb-2.jpg",
      detail: "01.06.2019",
      category: "Cakes",
      badges: [
        {
          color: "theme-2",
          title: "DONE"
        },
        {
          color: "primary",
          title: "TRENDING"
        }
      ]
    },
    {
      id: 3,
      title: "3 Cheesecake with Chocolate Cookies and Cream Biscuits",
      img: "/assets/img/card-thumb-3.jpg",
      detail: "27.05.2019",
      category: "Cupcakes",
      badges: [
        {
          color: "secondary",
          title: "PROCESSED"
        }
      ]
    },
    {
      id: 4,
      title: "4 Homemade Cheesecake with Fresh Berries and Mint",
      img: "/assets/img/card-thumb-1.jpg",
      detail: "10.12.2019",
      category: "Cakes",
      badges: [
        {
          color: "primary",
          title: "NEW"
        }
      ]
    },
    {
      id: 5,
      title: "5 Cheesecake with Chocolate Cookies and Cream Biscuits",
      img: "/assets/img/card-thumb-3.jpg",
      detail: "27.05.2019",
      category: "Cupcakes",
      badges: [
        {
          color: "theme-3",
          title: "PROCESSED"
        }
      ]
    }
  ];
  export default items;